/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 13.10.2016.
 */

import {PendingState, SuccessState, ErrorState} from '../../utils';

import {INIT_PURCHASE, STRIPE_PROCESS, ACK_PURCHASE, CLEAR_PAYMENT, GET_PURCHASES, GET_SUBSCRIPTION, CANCEL_PURCHASE} from '../../actions/purchase/actions-purchase';
import {GET_METADATA, GET_METADATA_ON_LOGIN} from '../../actions/common/actions-common';
import {EMIT_COLLECTION_PURCHASES_UPDATE, EMIT_COLLECTION_SUBSCRIPTIONS_UPDATE} from '../../actions/emit/actions-emit';

import _get from 'lodash/get';
import _omit from 'lodash/omit';

const INIT_STATE = {
  purchases: [],
  subscriptions: [],
  payment: {},
  cancel: {}
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {

    case PendingState(INIT_PURCHASE):

      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            state: 'init',
            initInProgress: true
          }
        }
      };

    case SuccessState(INIT_PURCHASE):

      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            state: 'init',
            initInProgress: false,
            tx: action.payload
          }
        }
      };

    case ErrorState(INIT_PURCHASE):

      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            state: 'error',
            initInProgress: false,
            message: _get(action.payload, 'message', 'Init error')
          }
        }
      };

    case PendingState(STRIPE_PROCESS):

      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            ...state.payment[action.meta.asset],
            state: 'token',
            tokenInProgress: true
          }
        }
      };

    case SuccessState(STRIPE_PROCESS):

      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            ...state.payment[action.meta.asset],
            state: 'token',
            tokenInProgress: false,
            token: action.payload
          }
        }
      };

    case ErrorState(STRIPE_PROCESS):

      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            ...state.payment[action.meta.asset],
            state: 'error',
            tokenInProgress: false,
            message: _get(action.payload ,'message', 'Stripe error')
          }
        }
      };

    case PendingState(ACK_PURCHASE):

      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            ...state.payment[action.meta.asset],
            state: 'ack',
            ackInProgress: true
          }
        }
      };

    case SuccessState(ACK_PURCHASE):


      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            ...state.payment[action.meta.asset],
            state: 'ack',
            ackInProgress: false,
            purchase: action.payload
          }
        }
      };

    case ErrorState(ACK_PURCHASE):

      return {
        ...state,
        payment: {
          ...state.payment,
          [action.meta.asset]: {
            ...state.payment[action.meta.asset],
            state: 'error',
            ackInProgress: false,
            message: _get(action.payload, 'message', 'Ack error')
          }
        }
      };

    case PendingState(CANCEL_PURCHASE):

      return {
        ...state,
        cancel: {
          ...state.cancel,
          [action.meta.asset]: {
            ...state.cancel[action.meta.asset],
            state: 'cancel',
            cancelInProgress: true
          }
        }
      };

    case SuccessState(CANCEL_PURCHASE):


      return {
        ...state,
        cancel: {
          ...state.cancel,
          [action.meta.asset]: {
            ...state.cancel[action.meta.asset],
            state: 'done',
            cancelInProgress: false,
            purchase: action.payload
          }
        }
      };

    case ErrorState(CANCEL_PURCHASE):

      return {
        ...state,
        cancel: {
          ...state.cancel,
          [action.meta.asset]: {
            ...state.cancel[action.meta.asset],
            state: 'error',
            cancelInProgress: false,
            message: _get(action.payload, 'message', 'Cancel error')
          }
        }
      };

    case SuccessState(GET_PURCHASES):

      return {
        ...state,
        purchases: action.payload
      };

    case SuccessState(GET_SUBSCRIPTION):

      return {
        ...state,
        subscriptions: action.payload
      };

    case SuccessState(GET_METADATA):

      return {
        ...state,
        purchases: action.payload[4] || [],
        subscriptions: action.payload[5] || []
      };

    case SuccessState(GET_METADATA_ON_LOGIN):

      return {
        ...state,
        purchases: action.payload[4] || [],
        subscriptions: action.payload[5] || []
      };

    case CLEAR_PAYMENT:

      return {
        ...state,
        payment: _omit(state.payment, [action.meta.asset])
      };

    default:

      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/purchase/reducer-purchase.js